// coffeelint: disable
var hasProp = {}.hasOwnProperty;

angular.module('model', []).factory('Model', [
  '$http',
  '$q',
  function(http,
  q) {
    var Model;
    return Model = class Model {
      constructor() {
        this.initialize(...arguments);
      }

      initialize(attrs,
  params = {},
  asLoad = false) {
        if (asLoad) {
          this.load(attrs);
        } else {
          this.update(attrs);
        }
        this._params = params;
        this._wraps || (this._wraps = {});
        return this._model = this;
      }

      id() {
        return this.attributes.id;
      }

      parent() {
        return this._params.parent;
      }

      collection() {
        return this._params.collection;
      }

      attr_key() {
        return this._params.attr_key;
      }

      link(rel) {
        var i,
  len,
  link,
  ref;
        ref = this.links();
        for (i = 0, len = ref.length; i < len; i++) {
          link = ref[i];
          if (link.rel === rel) {
            return link.href;
          }
        }
      }

      links() {
        return this.attributes.links || [];
      }

      error(field) {
        return this.errors()[field];
      }

      errors() {
        return this.attributes.errors || {};
      }

      static find(id,
  base = {}) {
        var elementId,
  lowerName,
  params,
  path,
  ref;
        params = _.extend({},
  base,
  {
          id: id
        });
        lowerName = (ref = this.name) != null ? ref.toLowerCase() : void 0;
        path = `/gyms/${params.id}`;
        elementId = "#gym-data";
        return q.when(this.preload(elementId) || this.load(path)).then((data) => {
          return new this(data,
  {},
  true);
        });
      }

      static load(path) {
        return http({
          method: 'GET',
          url: path
        }).then(function(result) {
          return result.data;
        });
      }

      static preload(id) {
        var attrs,
  el;
        if ((el = $(id)).length) {
          attrs = $.parseJSON(el.html());
          el.remove();
          return attrs;
        } else {
          return false;
        }
      }

      isNew() {
        return !this._original_attributes && !this.attributes.id;
      }

      isValid() {
        return _.isEmpty(this.errors());
      }

      isPersisted(current = this.attributes,
  clean = this._original_attributes) {
        if (!clean) {
          return false;
        }
        return _.isEqual(current,
  clean) && _.every(_.values(this._wraps),
  function(wrap) {
          return wrap.isPersisted();
        });
      }

      isDirty() {
        return !this.isPersisted(...arguments);
      }

      is(matcher) {
        return matcher(this.attributes);
      }

      update(attrs = {},
  deleteUndefined = false) {
        var k,
  ref,
  v;
        if (_.isUndefined(this.attributes)) {
          this.attributes = attrs;
          this.attributes._model = this;
        } else {
          ref = this.attributes;
          for (k in ref) {
            if (!hasProp.call(ref, k)) continue;
            v = ref[k];
            // skip reflection attr
            if (k === '_model') {
              continue;
            }
            if (_.isUndefined(attrs[k])) {
              if (deleteUndefined) {
                delete this.attributes[k];
              }
            } else if (this._wraps[k] != null) {
              this.attributes[k]._model.update(attrs[k]);
            } else if (_.isArray(this.attributes[k]) && _.isArray(attrs[k])) {
              // maintain array references
              this.attributes[k].splice(0,
  this.attributes[k].length,
  ...attrs[k]);
            } else if (_.isObject(this.attributes[k]) && _.isObject(attrs[k])) {
              _.extend(this.attributes[k],
  attrs[k]);
            } else {
              this.attributes[k] = attrs[k];
            }
          }
          // set attrs not yet set
          _.defaults(this.attributes,
  attrs);
        }
        return this;
      }

      load(attrs = {}) {
        var k,
  ref,
  v;
        this.update(attrs,
  true);
        this._original_attributes = _.extend({},
  this.attributes);
        ref = this._original_attributes;
        for (k in ref) {
          if (!hasProp.call(ref, k)) continue;
          v = ref[k];
          if (_.isArray(v)) {
            this._original_attributes[k] = [].concat(v);
          }
        }
        return this;
      }

      reset(newDeletes = true) {
        if (this.isNew() && newDeletes) {
          this.delete();
        }
        this.update(this._original_attributes || {},
  true);
        _.each(_.values(this._wraps),
  function(wrap) {
          return wrap.reset();
        });
        return this;
      }

      reload() {
        if (this.parent() && !this.collection() && this.isNew()) {
          return http({
            method: 'GET',
            url: this.parent().link(this.attr_key())
          }).then((result) => {
            return this.load(result.data);
          });
        } else if (this.isNew()) {
          // should return a promise here that
          // imediately resolves to self
          this.reset(false);
          return q.when(this);
        } else {
          return http({
            method: 'GET',
            url: this.link('self')
          }).then((result) => {
            return this.load(result.data);
          });
        }
      }

      asJson() {
        var attrs,
  k,
  ref,
  v;
        attrs = _.clone(this.attributes);
        ref = this._wraps;
        for (k in ref) {
          v = ref[k];
          attrs[k] = v.asJson();
        }
        delete attrs._model;
        delete attrs.links;
        delete attrs.$$hashKey;
        return attrs;
      }

      save(json = this.asJson()) {
        var data,
  link,
  method,
  name,
  ref,
  ref1,
  wrap;
        // clear errors
        this.attributes.errors = {};
        data = {};
        if (_.isEmpty(link = this.link('self')) && _.isEmpty(link = (ref = this.collection()) != null ? ref.link() : void 0) && _.isEmpty(link = (ref1 = this.parent()) != null ? ref1.link(this.attr_key()) : void 0)) {
          if (this.parent().isNew()) {
            return q.when(this.parent());
          }
          // save through parent
          wrap = _.find(_.pairs(this.parent()._wraps),
  (w) => {
            return w[1] === this || (_.isArray(w[1]) && w[1].contains(this));
          });
          data[wrap[0]] = _.isArray(wrap[1]) ? [json] : json;
          return this.parent().save(data);
        } else {
          name = this.constructor.param != null ? this.constructor.param : this.constructor.name.toLowerCase();
          data[name] = json;
          method = this.isNew() ? 'POST' : 'PATCH';
          return http({
            method: method,
            data: data,
            url: link // @collection().link
          // success
          }).then((args) => {
            return this.load(args.data);
          },
  // fail
  (args) => {
            this.update(args.data);
            return q.reject(args);
          });
        }
      }

      delete() {
        var removeFromCol;
        removeFromCol = () => {
          var col;
          if (col = this.collection()) {
            return col.remove(col.indexOf(this));
          }
        };
        if (this.isNew()) {
          return q.when(null).then(removeFromCol);
        } else {
          return http({
            method: 'DELETE',
            url: this.link('self')
          }).then(removeFromCol);
        }
      }

      dupe() {
        var result;
        result = _.clone(this.attributes);
        delete result.id;
        delete result.links;
        delete result._model;
        delete result.$$hashKey;
        return result;
      }

      wrap(key,
  model,
  params = {}) {
        var _wrap,
  base1,
  obj;
        params = _.extend({
          parent: this,
          attr_key: key
        },
  params);
        _wrap = function(item = {},
  asLoad = false) {
          if (item._model != null) {
            return item._model;
          } else {
            return new model(item,
  params,
  asLoad);
          }
        };
        obj = (this._wraps || (this._wraps = {}))[key] = _wrap((base1 = this.attributes)[key] || (base1[key] = {}),
  !(_.isEmpty(this.attributes[key])));
        return function() {
          return obj;
        };
      }

      wrapCollection(key,
  model,
  params = {}) {
        var base1,
  collection,
  parent,
  underscore;
        parent = this;
        if (_.isString(key)) {
          collection = (base1 = this.attributes)[key] || (base1[key] = []);
          (this._wraps || (this._wraps = {}))[key] = collection;
          collection.link = function() {
            return parent.link(key);
          };
        } else {
          collection = key;
        }
        params = _.extend({
          parent: parent,
          collection: collection,
          attr_key: key
        },
  params);
        collection.parent = function() {
          return parent;
        };
        collection._model = collection;
        collection.initialize = function() {
          var i,
  item,
  len,
  ref,
  results;
          ref = this;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            results.push(this._wrap(item,
  true));
          }
          return results;
        };
        collection.load = function(items = []) {
          // TODO: merge array content
          this.splice(0,
  this.length,
  ...items);
          this.initialize();
          return this;
        };
        collection.update = collection.load;
        collection.reload = function(data = {}) {
          collection.loading = true;
          return http({
            method: 'GET',
            url: this.link(),
            params: data
          }).then((result) => {
            collection.loading = false;
            return this.load(result.data);
          });
        };
        // Wrap underscore methods
        underscore = function(method) {
          return function(func) {
            return _[method](collection,
  (item) => {
              return func(collection._wrap(item));
            });
          };
        };
        _.each(['each',
  'map',
  'any',
  'every'],
  function(method) {
          return collection[method] = underscore(method);
        });
        collection.findBy = function(func) {
          var result;
          return (result = underscore('find')(func)) && this._wrap(result);
        };
        collection.find_by = collection.findBy;
        collection.where = function(match) {
          return this.findBy(function(item) {
            return item.is(_.matches(match));
          });
        };
        collection._wrap = function(item = {},
  asLoad = false) {
          if (item._model != null) {
            return item._model;
          } else {
            return new model(item,
  params,
  asLoad);
          }
        };
        collection.find = function(id) {
          var i,
  item,
  len,
  ref;
          ref = this;
          for (i = 0, len = ref.length; i < len; i++) {
            item = ref[i];
            if (item.id === +id) {
              return this._wrap(item);
            }
          }
        };
        collection.wrapAll = function() {
          return _.map(this,
  (item) => {
            return this._wrap(item);
          });
        };
        collection.indexOf = function(thing) {
          var i,
  index,
  item,
  len,
  ref;
          ref = this;
          for (index = i = 0, len = ref.length; i < len; index = ++i) {
            item = ref[index];
            if (item === thing || this._wrap(item) === thing) {
              return index;
            }
          }
        };
        collection.contains = function(thing) {
          return this.indexOf(thing) != null;
        };
        collection.build = function(attrs = {},
  index = this.length) {
          if (attrs._model != null) {
            attrs = attrs._model.dupe();
          }
          return this.add(attrs,
  index);
        };
        collection.add = function(item,
  index = 0) {
          var obj;
          item.position = index;
          obj = this._wrap(item);
          this.splice(index,
  0,
  item);
          return obj;
        };
        collection.move = function(from,
  to) {
          var item;
          item = this.remove(from);
          item.position = to;
          this.splice(to,
  0,
  item);
          return this._wrap(item);
        };
        collection.remove = function(index) {
          return this.splice(index,
  1)[0];
        };
        collection.asJson = function() {
          return this.map(function(item) {
            return item.asJson();
          });
        };
        collection.isPersisted = function() {
          return this.every(function(item) {
            return item.isPersisted();
          });
        };
        collection.reset = function() {
          return this.each(function(item) {
            return item.reset;
          });
        };
        collection.initialize();
        return function() {
          return collection;
        };
      }

      wrapPaginated(key,
  model,
  params = {}) {
        var collection,
  paginated;
        if (_.isString(key)) {
          paginated = this.attributes[key] || {};
          collection = this.attributes[key] = paginated.collection || (paginated.collection = []);
          this.wrapCollection(key,
  model,
  params);
        } else {
          paginated = key;
          collection = paginated.collection || (paginated.collection = []);
          this.wrapCollection(collection,
  model,
  params);
        }
        delete paginated['collection'];
        collection.page = function() {
          return paginated.page;
        };
        collection.search = function() {
          return paginated.search;
        };
        collection.count = function() {
          return paginated.count;
        };
        collection.total = function() {
          return paginated.total;
        };
        collection.order = function() {
          return paginated.order;
        };
        collection.loadCollection = collection.load;
        collection.load = function(data = []) {
          if (_.isArray(data)) {
            return collection.loadCollection(data);
          } else {
            _.extend(paginated,
  data);
            collection.loadCollection(paginated['collection']);
            delete paginated['collection'];
            return collection;
          }
        };
        collection.findInCollection = collection.find;
        collection.find = function(id) {
          var item;
          if (item = collection.findInCollection(id)) {
            return q.when(item);
          }
          return model.load(`${collection.link()}/${id}`).then(function(data) {
            return collection._wrap(data);
          });
        };
        collection.loadPage = function(page,
  options = {}) {
          return collection.reload(_.extend(options,
  {
            page: page
          }));
        };
        collection.search = function(str,
  options = {}) {
          return collection.reload(_.extend(options,
  {
            search: str
          }));
        };
        collection.reload = function(options = {}) {
          options = _.extend({},
  paginated,
  options);
          collection.loading = true;
          return http({
            method: 'GET',
            url: this.link(),
            params: options
          }).then((result) => {
            collection.loading = false;
            return this.load(result.data);
          });
        };
        collection.collectionAsJson = collection.asJson;
        collection.asJson = function() {
          var json;
          json = _.clone(paginated);
          json.collection = collection.collectionAsJson;
          return json;
        };
        return function() {
          return collection;
        };
      }

    };
  }
]);

// coffeelint: enable
